import { combineReducers } from 'redux';

import authError from './authError';
import loginError from './loginError';
import logoutError from './logoutError';
import askUnsuspendError from './askUnsuspendError';
import changePasswordError from './changePasswordError';
import deleteAccountError from './deleteAccountError';
import deleteNotificationError from './deleteNotificationError';


export default combineReducers({
  authError,
  loginError,
  logoutError,
  askUnsuspendError,
  changePasswordError,
  deleteAccountError,
  deleteNotificationError,
});
